import { useEffect,useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Alert, Avatar, Box, Card, CardContent, Divider, Fade, Grid, IconButton, List, ListItem, ListItemAvatar, ListItemText, Modal, Typography } from '@mui/material'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import CreateIcon from '@mui/icons-material/Create'
import { post } from '../../../utils/axios'
import Button from '../../../components/Button'

import './Addresses.css'
import { Delete } from '@mui/icons-material';
import { toast } from 'react-toastify';

const Addresses = () => {

    const navigate = useNavigate()

    const [isLoading,setIsLoading] = useState(true)
    const [isDeleteLoading,setIsDeleteLoading] = useState(false)
    const [addresses,setAddresses] = useState([])
    const [currentAddress,setCurrentAddress] = useState({})
    const [openModal,setOpenModal] = useState(false)

    const getData = () => {
        post('Address/GetAllAddressByPersonId').then(({data}) => {
            if(data.isSuccess)
                setAddresses(data.data)
        }).finally(() => setIsLoading(false))
    }

    useEffect(() => {
        getData()
    },[])

    const setCurrentAddressMethod = addressId => {
        const address = addresses.find(ad => ad.id == addressId)
        setCurrentAddress(address)
        setOpenModal(true)
    }

    const deleteAddress = id => {
        setIsDeleteLoading(true)
        const postedData = {
            id,
            isActive: false
        }
        post('Address/ChangeStatusAddress',postedData).then(({data}) => {
            if(data.isSuccess){
                toast.success('آدرس مورد نظر با موفقیت حذف شد')
                setIsLoading(true)
                getData()
            }else
                toast.error(data.message)
        }).finally(() => {
            setIsDeleteLoading(false)
            setOpenModal(false)
        })
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '92%',
        boxSizing: 'border-box',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    }

    return (
        <Grid item px={0.3}>
            <h3 className="others-page-title">افزودن آدرس جدید</h3>
            <div className="safe-area">
                <Card sx={{width: '100%',mb: 2}}>
                    <CardContent>
                        <Button variant="contained" color="secondary" sx={{mt: 0.5,mb: 1}} onClick={() => navigate('/app/profile/addresses/add')}>افزودن آدرس</Button>
                        {isLoading ? <List sx={{py: 0,my: 0}}>
                            {[...Array(4)].map((item,index) => <ListItem key={index} sx={{px: 0}} secondaryAction={<IconButton edge="end" className="edit-address-btn-placeholder animate"></IconButton>}>
                                <ListItemAvatar><Avatar><LocationOnIcon /></Avatar></ListItemAvatar>
                                <p className="edit-address-title-placeholder animate"></p>
                            </ListItem>)}
                        </List> : (addresses.length ? <List sx={{py: 0,my: 0}}>
                            {addresses.map(address => <ListItem key={address.id} sx={{px: 0}} secondaryAction={<><IconButton edge="end" onClick={() => navigate(`/app/profile/addresses/${address.id}`)} sx={{mr: 0}}><CreateIcon /></IconButton><IconButton edge="end" onClick={() => setCurrentAddressMethod(address.id)}><Delete /></IconButton></>}>
                                <ListItemAvatar><Avatar><LocationOnIcon /></Avatar></ListItemAvatar>
                                <ListItemText primary={address.title} secondary={`${address.address.slice(0,20)}${address.address.length > 20 ? ' ...' : ''}`} />
                            </ListItem>)}
                        </List> : <Alert severity="info" sx={{my: 3}}>تا کنون آدرسی در سیستم ثبت نشده است</Alert>)}
                    </CardContent>
                </Card>
            </div>
            <Modal open={openModal} onClose={() => setOpenModal(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Fade in={openModal}>
                    <Box sx={style}>
                        <Typography variant="h6" component="h2" sx={{ fontSize: 18 }}>حذف آدرس {currentAddress.title}</Typography>
                        <Divider sx={{mt: 2,mb: 2.5}} />
                        <div id="miss-card-modal">
                            <p>این عملیات غیر قابل بازگشت است. اطمینان دارید ؟</p>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <Button isLoading={isDeleteLoading} fullWidth variant="contained" sx={{py: 1.5}} color="primary" onClick={() => deleteAddress(currentAddress.id)}>حذف</Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Button fullWidth variant="outlined" sx={{py: 1.5}} color="error" onClick={() => setOpenModal(false)}>لغو</Button>
                                </Grid>
                            </Grid>
                        </div>                        
                    </Box>
                </Fade>
            </Modal>
        </Grid>
    )
}

export default Addresses